import createBrowserHistory from "history/es/createBrowserHistory";


export let history = createBrowserHistory({basename: ""});
